// AboutSection.js
import React from "react";
import { NumberItem } from "../modules/NumberItem";
import { Fade } from "react-awesome-reveal";

const AboutSection = () => {
	const numberItems = [
		{
			iconClass: "fa fa-rocket",
			number: "⚡",
			title: "Propelling Innovation at Light Speed",
		},
		{
			iconClass: "fa fa-brain",
			number: "100%",
			title: "Quantum Mind Beyond Algorithms",
		},
		{
			iconClass: "fa fa-code-branch",
			number: "100K+",
			title: "Mastered Node.js & React.js Development",
		},
	];

	const paragraphs = [
		`Welcome to where code meets caffeine and innovation never sleeps! I'm <strong>Murtaza Lightwala</strong>, an Associate Team Lead and <strong>Full Stack Developer</strong> specializing in <strong>Node.js</strong> and <strong>React.js</strong>. Based in <strong>Indore</strong>, I don't just write code—I weave digital magic that brings groundbreaking ideas to life.`,
		`With over 4.6 years of battling bugs and conquering code, I've mastered the art of turning coffee into code and challenges into opportunities. As an <strong>AI expert</strong>, <strong>Machine Learning enthusiast</strong>, and seasoned <strong>Software Engineer</strong>, I, <strong>Murtaza Lightwala</strong>, integrate intelligent algorithms that make applications not just smart, but revolutionary.`,
		`Ready to join forces and create the next big thing in tech? Let's push the boundaries of <strong>Full Stack Development</strong>, embrace cutting-edge <strong>Artificial Intelligence</strong>, and craft seamless user experiences that set new industry standards. Connect with <strong>Murtaza Lightwala</strong> today, and together we'll not only meet the future—we'll code it!`,
	];

	return (
		<section
			className="section section-bg section-parallax-1"
			id="about-section"
			style={{ textAlign: "left" }}
		>
			<div className="container">
				{/* Section Heading */}
				<Fade direction="up" triggerOnce>
				<header className="m-titles">
					<h2
						className="m-title"
						data-animate="active"
					>
						About Me
					</h2>
				</header>
				</Fade>

				<div className="row row-custom">
					<aside className="col-xs-12 col-sm-12 col-md-3 col-lg-3 align-right">
						{/* Section numbers */}

						<div className="numbers-items">
						<Fade direction="up" className="numbers-item" cascade={true} triggerOnce >
							{numberItems.map((item, index) => (
								<NumberItem
									key={index}
									iconClass={item.iconClass}
									number={item.number}
									title={item.title}
								/>
							))}
						</Fade>
						</div>

					</aside>
					<article className="col-xs-12 col-sm-12 col-md-9 col-lg-9 vertical-line">
						{/* Section Profile */}
						<div className="profile-box">
							<div
								className="text"
							>
							<Fade direction="up" className="text" style={{marginBottom: "1.5em"}} triggerOnce cascade={true} damping={0.5}>
								{paragraphs.map((text, index) => (
									<p
										key={index}
										style={{ textAlign: "justify" }}
										dangerouslySetInnerHTML={{ __html: text }}
									/>
								))}
								<a
									href="assets/docs/resume/Murtaza_Lightwala_resume.pdf"
									target="_blank"
									className="btn"
									rel="noopener noreferrer"
								>
									Download Resume
								</a>
							</Fade>
							</div>
						</div>
					</article>
				</div>
			</div>
		</section>
	);
};

export default AboutSection;
